import { Modal, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useMutation } from "@apollo/client";
import { toast } from "react-toastify";
import { DELETE_SITE_MEASUREMENT } from "../../../../graphql/mutations";

const DeleteSiteMeasurementModal = ({
  show,
  siteMeasurement,
  handleClose,
  env,
  handleEnvChange,
  currentTenant,
  currentTenantName,
  currentGroupVersion
}) => {
  const navigate = useNavigate();
  const [deleteSiteMeasurement, { loading: mutationLoading }] = useMutation(DELETE_SITE_MEASUREMENT);

  const handleDelete = async (e) => {
    e.preventDefault();

    try {
      const { data } = await deleteSiteMeasurement({
        variables: {
          id: siteMeasurement.id
        }
      });

      if (data?.deleteUser) {
        setTimeout(() => {
          toast.success(`Database site measurement with ID: ${data?.deleteSiteMeasurement} deleted successfully`);
        }, 200);
      }
    } catch (error) {
      setTimeout(() => {
        toast.error("Failed to delete database user.");
      }, 200);
    } finally {
      handleClose();
      handleEnvChange(env, currentTenant, currentTenantName, currentGroupVersion);
      navigate("/measurements");
    }
  };
  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Delete Site Measurement</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Are you sure you want to delete site measurement <strong>{siteMeasurement.id}</strong>?
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={handleClose}>
          No
        </Button>
        <Button variant="danger" onClick={handleDelete}>
          {mutationLoading ? "Deleting tenant..." : "Yes"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
export { DeleteSiteMeasurementModal };
